import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBri1FZiGQ7fCg0K38nGFWNwqK0eotjX2k",
  authDomain: "printer-rental-app.firebaseapp.com",
  projectId: "printer-rental-app",
  storageBucket: "printer-rental-app.firebasestorage.app",
  messagingSenderId: "86363652601",
  appId: "1:86363652601:web:5656d08b6bd13a01613d28"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore Database
export const db = getFirestore(app);

// Initialize Authentication
export const auth = getAuth(app);

// Initialize Cloud Storage (for rental agreement document uploads)
export const storage = getStorage(app);

// Initialize Functions (India region) - used by renewal reminder Cloud Function
export const functions = getFunctions(app, 'asia-south1');

export default app;
